export default "__VITE_ASSET__BAeHqAIW__"